import { useEffect, useState } from "react";

interface IUseDropDownMenuState {
  isOpen: boolean;
  handleCloseMenu: () => void;
  handleOpenMenu: () => void;
}

export const useDropDownMenuState = (): IUseDropDownMenuState => {
  const currentValue = false;
  const [isOpen, setIsOpen] = useState(currentValue);

  const handleCloseMenu = () => {
    setIsOpen(false);
  };

  const handleOpenMenu = () => {
    setIsOpen(true);
  };

  useEffect(() => {
    if (currentValue !== undefined) {
      setIsOpen(currentValue);
    }
  }, [currentValue]);

  return { isOpen, handleCloseMenu, handleOpenMenu };
};
